module.exports = __webpack_public_path__ + "static/img/home-banner.7257bf32.png";